import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PublicApIsService } from 'src/app/cc-api/services/public-ap-is.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private featureFlags = {};
  private saasSettings;
  private _isSaaSCP: boolean = false;
  featureFlagsLoaded: boolean = false;

  constructor(private publicApIsService: PublicApIsService) {}

  getAllFeatureFlags() {
    return new Promise((resolve, reject) => {
      this.publicApIsService.getAllFeaturePropertiesUsingGET().subscribe(
        (response) => {
          this.featureFlags = response;
          if (this.featureFlags['FEATURE_SAAS_SETTINGS']) {
            try {
              this.saasSettings = JSON.parse(
                this.featureFlags['FEATURE_SAAS_SETTINGS'] || '{}',
              );
            } catch (error) {}

            this._isSaaSCP = this.saasSettings?.IS_SAAS_CP;
          }
          resolve(true);
        },
        (error) => {
          this.featureFlags = {};
          reject(error);
        },
      );
    });
  }

  resetData() {
    this.featureFlags = {};
  }

  getThemeName() {
    return this.featureFlags['FEATURE_THEME_NAME'] || 'facets';
  }

  getSidebarLogoName() {
    return this.featureFlags['FEATURE_SIDEBAR_LOGO'] || 'facets-logo-full';
  }

  getGlobalLoaderGifName() {
    return this.featureFlags['FEATURE_GLOBAL_LOADER_ICON'] || 'facets-animated';
  }

  getFavIcon() {
    return (
      this.featureFlags['FEATURE_FAVICON'] ||
      'https://uploads-ssl.webflow.com/6252ef50a9f5d4afb6983bc3/62909661b8294214e3f39734_facets-logo-256x256.png'
    );
  }

  getClickupTicketUrl() {
    return this.featureFlags['FEATURE_CLICKUP_TICKET_URL'];
  }

  getSidebarItems() {
    return this.featureFlags['FEATURE_SIDEBAR_ITEMS'];
  }

  getLogoutUrl() {
    return this.featureFlags['FEATURE_LOGOUT_URL'];
  }

  getBlueprintRelativePath() {
    return this.featureFlags['FEATURE_BLUEPRINT_RELATIVE_PATH'] || '.';
  }

  getEnterpriseCustomerName() {
    return this.featureFlags['FEATURE_ENTERPRISE_CUSTOMER_NAME'] || 'facets';
  }

  get isMercedesCP() {
    return this.featureFlags['FEATURE_ENTERPRISE_CUSTOMER_NAME'] === 'mercedes';
  }

  get showExternalDoc() {
    return !!this.featureFlags['FEATURE_DOCS_LINK'];
  }

  getEnterpriseLogo() {
    return (
      this.featureFlags?.['FEATURE_ENTERPRISE_LOGO_LINK'] ||
      'https://uploads-ssl.webflow.com/6252ef50a9f5d4afb6983bc3/6583f506bcc4b0a0f183dfe8_Group%207202.svg'
    );
  }

  getDocsLink() {
    return (
      this.featureFlags['FEATURE_DOCS_LINK'] ||
      'https://readme.facets.cloud/docs/what-is-facets-1'
    );
  }

  getIsMonoRepo() {
    return this.featureFlags['FEATURE_IS_MONO_REPO'] || false;
  }

  getHideAssistantStatus() {
    return this.featureFlags['FEATURE_HIDE_AI_ASSISTANT'] || false;
  }

  getBranchSelectorFlag() {
    return this.featureFlags['FEATURE_SHOW_BP_BRANCH_SELECTION'] || false;
  }

  allowThemeCustomization() {
    return this.featureFlags['FEATURE_ALLOW_THEME_CUSTOMIZATION'] || false;
  }

  showFooterBranding() {
    return this.featureFlags['FEATURE_SHOW_FOOTER_BRANDING'] || false;
  }

  showWebComponents() {
    return true;
  }

  get isSaaSCP() {
    return this._isSaaSCP;
  }

  getProjectRouteTabs() {
    if (this.saasSettings?.IS_SAAS_CP) {
      return this.saasSettings?.PROJECT_TABS || [];
    }
    return [];
  }
  getEnvironmentRouteTabs() {
    if (this.saasSettings?.IS_SAAS_CP) {
      return this.saasSettings?.ENVIRONMENT_TABS || [];
    }
    return [];
  }
  getResourceRouteTabs() {
    if (this.saasSettings?.IS_SAAS_CP) {
      return this.saasSettings?.RESOURCE_TABS || [];
    }
    return [];
  }
  getHotjarSiteId() {
    const PAAS_HOTJAR_SITE_ID = 3093562;
    return (
      Number(this.featureFlags['FEATURE_HOTJAR_SITE_ID']) || PAAS_HOTJAR_SITE_ID
    );
  }

  get showAIAssistant() {
    return this.featureFlags['FEATURE_SHOW_AI_ASSISTANT'];
  }

  get hideUISwitch() {
    return this.featureFlags['FEATURE_HIDE_UI_SWITCH'];
  }

  get browserTitle() {
    return this.isMercedesCP ? 'cliMB' : 'Facets Control Plane';
  }

  get mercedesGuidelinesURL() {
    return this.isMercedesCP
      ? this.featureFlags['FEATURE_MERCEDES_SWE_GUIDELINES_URL']
      : '';
  }

  get getInnerSourcingURL() {
    return (
      this.featureFlags['FEATURE_INNER_SOURCING_URL'] ||
      'https://readme.facets.cloud/docs/introduction/'
    );
  }

  get showStructuredTerraformLogs() {
    return this.featureFlags['FEATURE_SHOW_STRUCTURED_TERRAFORM_LOGS'] || false;
  }
}
